import * as THREE from 'three';
import * as marietta from '../../../..';
import { ThreeView } from '../../../../view3d/webcad';
import { PinDialogUtil } from '../../../../view3d/webcad/util/PinDialogUtil';
import PinPictureInfoDialog from '../PinPictureInfoDialog';

type hitItemType = marietta.webcad.item.MonicaObject | marietta.webcad.item.parts.Wall;

export class WizardPinIntersect extends PinPictureInfoDialog {

    private hitItem: hitItemType = null;

    private dialogBodyContainer: HTMLElement = null;

    static pinList: marietta.webcad.item.PinPicture[] = [];

    static currentIndex: number = 0;

    constructor(draggable: boolean) {
      super(draggable);
    }

    public buildContent(): void {
      this.parentObj = WizardPinIntersect.pinList[WizardPinIntersect.currentIndex];

      const id = 'WizardPinIntersect';
      const title = (marietta.webcad.WebCADGlobal.language === 'jp') ?
                      'ピン編集ウィザード' : 'Specify items to be associated with the pin';

      const contents = '';

      const footer = `
        <button id="btnNext"><span class="jp">次へ</span><span class="en">OK</span></button>
      `;

      this.createDialog(id, title, contents, footer);

      this.createContents(this.parentObj.itemInfo);
      this.createEventListner();

      // Event 設定
      (<HTMLButtonElement>document.getElementById('btnNext')).addEventListener('click', this.onOkBtn);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = true;
      marietta.webcad.WebCADGlobal.itemManager.showOrHidePin();

      this.next();
      $("#modalBg").hide();

      //編集モード
      if( !this.view_mode ){
        this.btnEditEvent();
      }
    }

    protected createContents(itemInfo: marietta.webcad.collection.ItemInfoCollection): void {
      this.dialogBodyContainer = document.createElement('div');
      this.dialogBodyContainer.classList.add('dialogPinIntersectContainer');

      // 説明文
      {
        const explainLabel = document.createElement('label');
        explainLabel.classList.add('explainContents');
        {
          const explainSpanJP = document.createElement('span');
          explainSpanJP.classList.add('jp');
          explainSpanJP.textContent = '編集完了した後、「次へ」ボタンを押してください。';
          explainLabel.appendChild(explainSpanJP);
          const explainSpanEN = document.createElement('span');
          explainSpanEN.classList.add('en');
          explainSpanEN.textContent = 'When editing is complete, press the Next button.';
          explainLabel.appendChild(explainSpanEN);
        }
        this.dialogBodyContainer.appendChild(explainLabel);
      }

      // ピンの編集画面
      super.createContents(itemInfo);
      this.dialogBodyContainer.appendChild(this.textGroupViewHtml);

      const dialogBody = document.querySelector('#WizardPinIntersect .dialogBody');
      dialogBody.appendChild(this.dialogBodyContainer);
    }

    /**
     * 種類ボタンが選択された
     */
    private onOkBtn = (e: Event): void => {
      e.preventDefault();
      this.saveData();

      if (WizardPinIntersect.pinList.length == WizardPinIntersect.currentIndex) {
        this.finish();
        this.close();
        return;
      }

      this.parentObj = WizardPinIntersect.pinList[WizardPinIntersect.currentIndex];

      this.dialogBodyContainer?.remove();
      this.createContents(this.parentObj.itemInfo);
      this.createEventListner();
      //編集モード
      if( !this.view_mode ){
        this.btnEditEvent();
      }

      this.next();
    }

    /**
     * 次のピンへ
     */
    private next = () => {
      marietta.webcad.WebCADGlobal.itemManager.currentItem = null;
      marietta.webcad.WebCADGlobal.itemManager.currentWall = null;

      if (this.parentObj) this.parentObj.textHide();

      if (WizardPinIntersect.pinList.length == WizardPinIntersect.currentIndex) {
        this.finish();
        this.close();
        return;
      }

      this.parentObj.textShow();
      marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();

      this.scrollPosition(WizardPinIntersect.pinList[WizardPinIntersect.currentIndex]); // 画面位置調節
      this.reposition(WizardPinIntersect.pinList[WizardPinIntersect.currentIndex]); // ダイアログと青線位置調節

      this.displayListRadioBtn();

      this.hitItem = PinDialogUtil.getCurrentItem(this.parentObj.itemInfo.intersectItem.uid);

      this.modal(this.parentObj?.itemInfo?.floor, this.getHighlightBox(this.parentObj, this.hitItem)); // モーダル
      marietta.webcad.WebCADGlobal.itemManager.currentItem = this.parentObj;
      WizardPinIntersect.currentIndex += 1;
    }

    private displayListRadioBtn() {
      const changeBtn = (inputElement: HTMLInputElement) => {
        inputElement.checked = true;
        inputElement.dispatchEvent(new PointerEvent('change'));
      }

      if (PinDialogUtil.isWallTargetPinType(this.parentObj.itemInfo.intersectItem) ||
          PinDialogUtil.isCeilingTargetPinType(this.parentObj.itemInfo.intersectItem) ||
          PinDialogUtil.isFloorTargetPinType((this.parentObj.itemInfo.intersectItem))) {
        changeBtn(document.getElementById('checkInputRoomParts') as HTMLInputElement);
      }
      if (PinDialogUtil.isFittingTargetPinType(this.parentObj.itemInfo.intersectItem)) {
        changeBtn(document.getElementById('checkInputOpening') as HTMLInputElement);
      }
      if (PinDialogUtil.isEquTargetPinType(this.parentObj.itemInfo.intersectItem)) {
        changeBtn(document.getElementById('checkInputEquipment') as HTMLInputElement);
      }
      if (PinDialogUtil.isExtTargetPinType(this.parentObj.itemInfo.intersectItem)) {
        // TODO
        // changeBtn(document.getElementById('checkInputRoomParts') as HTMLInputElement);
      }
    }

    /**
       * 閉じるボタンが押された
       */
    public close = () => {
      // モーダルの削除
      $("#modalBgForRoomSelect").hide();

      this.closeEvent();

      // wizardの終了
      ThreeView.get().wizardManager.end();
    }

    /**
     * 次に選択する部屋が存在しない
     */
    private finish() {
      // パネルを閉じる
      this.closeEvent();
      // 青枠・モーダルの削除
      $("#modalBgForRoomSelect").hide();

      ThreeView.get().wizardManager.end();
    }

    /**
     * 画面の位置調節
     */
    private scrollPosition(pin: marietta.webcad.item.PinPicture): void {

        //部屋のバウンド
        const _bound = pin.viewObj.getBoundingClientRect();
        const bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

        // scroll the screen if object not in the visible screen
        const view2D: HTMLElement = document.getElementById("webcad2dViewInner");
        const currentScrollPosition: marietta.core.Point = new marietta.core.Point(view2D.scrollLeft, view2D.scrollTop);
        let { top, left, bottom, right } = view2D.getBoundingClientRect();
        let scrollBarWidth = view2D.offsetWidth - view2D.clientWidth;
        right = right - left - scrollBarWidth;
        bottom = bottom - top - scrollBarWidth;
        const margin = 100;
        let xDiff = 0;
        let yDiff = 0;
        if (bound.x < left) xDiff = bound.x - left - margin - bound.width;
        if (bound.y < top) yDiff = bound.y - top - margin - bound.height;

        if (bound.x > right) xDiff = bound.x - right + margin + bound.width;
        if (bound.y > bottom) yDiff = bound.y - bottom + margin + bound.height;

        marietta.webcad.WebCADGlobal.scrollerManager.setScrollPosition(currentScrollPosition.x + xDiff, currentScrollPosition.y + yDiff);

    }

    private getHighlightBox(targetPin: marietta.webcad.item.PinPicture, hitItem: hitItemType): THREE.Box2 {
      const getBoundingrect = (item: hitItemType): THREE.Box2 => {
        const _bound = item.viewObj.getBoundingClientRect();
        const pos = new THREE.Vector2(_bound.left - 5, _bound.top - 5);
        const size = new THREE.Vector2(_bound.width + 10, _bound.height + 10);
        const min = pos.clone();
        const max = pos.clone().add(size);
        return new THREE.Box2(min, max);
      }

      const box1 = getBoundingrect(targetPin);
      if (!hitItem) return box1;

      const box2 = getBoundingrect(hitItem);
      return box1.clone().union(box2);
    }

    /**
     * モーダル
     */
    private modal(floor: number, bound: THREE.Box2): void {

        //異なる階の場合は、階を変更する
        if (floor != marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor) {
          marietta.webcad.WebCADGlobal.changeFloor(floor);
        }

      //グレイを作る
      const path: string = "M0, 0" +
          "L" + window.innerWidth + ", 0" +
          "L" + window.innerWidth + "," + window.innerHeight +
          "L" + (bound.max.x) + "," + window.innerHeight +
          "L" + (bound.max.x) + "," + (bound.max.y) +
          "L" + (bound.max.x) + "," + bound.min.y +
          "L" + bound.min.x + "," + bound.min.y +
          "L" + bound.min.x + "," + (bound.max.y) +
          "L" + (bound.max.x) + "," + (bound.max.y) +
          "L" + (bound.max.x) + "," + window.innerHeight +
          "L 0," + window.innerHeight +
          "L 0, 0Z";
      document.getElementById("modalBgForRoomSelect_fill")?.setAttribute("d", path);

      $("#modalBgForRoomSelect").show();
      $("#modalBg").hide();

    }

    /**
     * ダイアログの位置調節
     */
    private reposition(target: marietta.webcad.item.PinPicture): any {
        //ダイアログの位置
        //部屋が右半分のところにある
        const _bound = target.viewObj.getBoundingClientRect();
        let bound: marietta.core.Rectangle = new marietta.core.Rectangle(_bound.left - 5, _bound.top - 5, _bound.width + 10, _bound.height + 10);

        const mybound = document.getElementById('WizardPinIntersect').getBoundingClientRect();
        // const margin: number = 100;
        let posX: number = 0;
        let posY: number = 0;

        // 上下左右の差分
        const top = bound.y;
        const bottom = window.innerHeight - (bound.y + bound.height);
        const right = window.innerWidth - (bound.x + bound.width);
        const left = bound.x;

        // 位置計算
        if (top > bottom && top > right && top > left) {
          posX = 0;
          posY = - top / 2 + mybound.height / 2;
        } else if (bottom > top && bottom > right && bottom > left) {
          posX = 0;
          posY = top / 2;
        } else if (right > top && right > bottom && right > left) {
          posX = left / 2;
          posY = 0;
        } else if (left > top && left > bottom && left > right) {
          posX = - left / 2 + mybound.width / 2;
          posY = 0;
        }

        // 画面いっぱいに表示されている場合は中央にする
        if (bound.height > top && bound.height > bottom && bound.width > left && bound.width > right) {
          posX = 0;
          posY = 0;
        }

        // 画面外のケースは中央にする
        if (posX < - window.innerWidth / 2 || window.innerWidth / 2 < posX
        || posY < - window.innerHeight / 2 || window.innerHeight / 2 < posY) {
          posX = 0;
          posY = 0;
        }

        this.dialogPosition.x = posX;
        this.dialogPosition.y = posY;

        const cssTransform = 'translate(' + posX + 'px,' + posY + 'px)';
        $(this.viewObj).css({ transform: cssTransform });

    }


}
